"use client";
import type { PropsWithChildren } from "react";
import { ProductViewerProvider } from "./product-viewer-provider";
import { useActualViewer } from "../../session/use-actual-viewer";

export function SiteViewerProvider({
  children,
  viewerId,
  signedIn,
}: PropsWithChildren<{
  readonly viewerId: string | null;
  readonly signedIn: boolean;
}>) {
  const viewer = useActualViewer();

  return (
    <ProductViewerProvider
      viewerId={viewerId}
      signedIn={signedIn}
      isSoftmaxTeamMember={
        signedIn &&
        viewer.data?.subject_id === viewerId &&
        viewer.data.is_softmax_team_member
      }
    >
      {children}
    </ProductViewerProvider>
  );
}
